import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
    },
    // Public creator self-verification (magic link from email — no admin login).
    {
        path: 'verify/:token',
        loadComponent: () => import('./components/creator-verify/creator-verify.component').then(m => m.CreatorVerifyComponent)
    },
    // Public creator token claim (magic link from email — no admin login).
    {
        path: 'claim/:token',
        loadComponent: () => import('./components/creator-claim/creator-claim.component').then(m => m.CreatorClaimComponent)
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
        // Post-login landing page — preload in the background (see SelectivePreloadStrategy)
        data: { preload: true }
    },
    {
        path: 'settings',
        loadComponent: () => import('./components/setting/setting.component').then(m => m.SettingComponent)
    },
    {
        path: 'testing',
        loadComponent: () => import('./components/testing/testing.component').then(m => m.TestingComponent)
    },
    {
        path: 'wallet-management',
        loadComponent: () => import('./components/wallet-management/wallet-management.component').then(m => m.WalletManagementComponent)
    }, 
    // {
    //     path: 'burn-tokens',
    //     loadComponent: () => import('./components/burn-tokens/burn-tokens.component').then(m => m.BurnTokensComponent)
    // },
    {
        path: 'white-list',
        loadComponent: () => import('./components/whitelist-address/whitelist-address.component').then(m => m.WhitelistAddressComponent)
    },
    {
        path:'approve-white-list-address',
        loadComponent: () => import('./components/approve-white-list-address/approve-white-list-address.component').then(m => m.ApproveWhiteListAddressComponent)
    },
    {
        path: 'rejected-white-list-address',
        loadComponent: () => import('./components/reject-white-list-address/reject-white-list-address.component').then(m => m.RejectWhiteListAddressComponent)
    },
    {
        path: 'staking-admin',
        loadComponent: () => import('./components/staking-admin/staking-admin.component').then(m => m.StakingAdminComponent)
    },
    {
        path: 'creator-pool',
        loadComponent: () => import('./components/creator-pool/creator-pool.component').then(m => m.CreatorPoolComponent)
    },
    // 'onboard' is declared before ':id' so it isn't captured as a creator id.
    {
        path: 'creator-pool/onboard',
        loadComponent: () => import('./components/creator-pool/creator-onboard/creator-onboard.component').then(m => m.CreatorOnboardComponent)
    },
    // Edit an existing creator — reuses the onboard form in edit mode.
    {
        path: 'creator-pool/:id/edit',
        loadComponent: () => import('./components/creator-pool/creator-onboard/creator-onboard.component').then(m => m.CreatorOnboardComponent)
    },
    {
        path: 'creator-pool/:id',
        loadComponent: () => import('./components/creator-pool/creator-detail/creator-detail.component').then(m => m.CreatorDetailComponent)
    }
];
